import type { CoachProfile } from '@efdigital/ll-addon-data';
import { queryCoachProfileByUserId } from '@efdigital/ll-xceed-v2/data/builders/coaching/coach-profiles';
import Route from '@ember/routing/route';
import { service } from '@ember/service';
import type { Store } from '@warp-drive/core';

import type { CoachingCoacheeCohortModel } from '../../cohort';

export type CoachingCoacheeCohortSessionsBookChemistryModel =
  CoachingCoacheeCohortModel & {
    coach: CoachProfile;
  };

export default class CoachingCoacheeCohortSessionsBookChemistryRoute extends Route<CoachingCoacheeCohortSessionsBookChemistryModel> {
  @service declare store: Store;

  async model(): Promise<CoachingCoacheeCohortSessionsBookChemistryModel> {
    const parentModel = this.modelFor(
      'coaching.coachee.cohort'
    ) as CoachingCoacheeCohortModel;

    const chosenCoachPartnership = parentModel.planner.chosenCoachPartnership();
    if (!chosenCoachPartnership) {
      throw new Error('No chosen coach partnership found');
    }

    const coachUserId = chosenCoachPartnership.coachUserId;

    const coaches = await this.store.request(
      queryCoachProfileByUserId(coachUserId, 'published')
    );
    const coach = coaches.content.data.find((c) => c.user === coachUserId);

    if (!coach) {
      throw new Error('Coach not found');
    }

    return {
      ...parentModel,
      coach,
    };
  }
}
